/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListInboxChatsTab } from './listInboxChatsTab';

export type ListInboxChatsParams = {
tab?: ListInboxChatsTab;
cursor?: string | null;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};
